/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * FormHelpText CSS
 */
export const styles = css`
  :host {
    width:100%;
    color: var(--nile-form-help-text-color, var(--ng-colors-text-tertiary-600));
    font-family: var(--nile-font-family-serif, var(--ng-font-family-body));
    font-size: var(--nile-form-help-text-font-size, var(--ng-font-size-text-sm));
    font-style: normal;
    line-height: var(--nile-form-help-text-line-height, var(--ng-line-height-text-sm));
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .nile-form-help-text {
    display:flex;
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-regular));
    letter-spacing: 0.2px;
    margin-top: var(--nile-spacing-sm, var(--ng-spacing-sm));
    margin-right: var(--nile-spacing-xs, var(--ng-spacing-xs));
    width: auto;
  }


  .nile-form-help-text--expanded{
    display:block;
  }

  .nile-form-help-text__more-button {
    display: inline-flex;
    gap: var(--nile-spacing-xs,var(--ng-spacing-xs));
    color: var(--nile-colors-primary-600, var(--ng-componentcolors-utility-brand-500));
    cursor: pointer;
    white-space: nowrap;
    align-items: center;
  }

  .help__text__full{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display:inline;
  }

  .help__text__full--expanded{
    white-space: wrap;
  }
`;

export default [styles];
